"use client";

import AddRow24 from "@ui/icons/24x24/add-row-24.svg";
import { cn } from "@ui/lib/utils";
import { useTranslations } from "next-intl";

import { addRow } from "../state/actions";
import { useSoundboard } from "../state/reducer";
import { SoundBoardButton } from "./SoundBoardButton";

export const AddRowButton = ({ className }: { className?: string }) => {
  const { dispatch } = useSoundboard();
  const t = useTranslations("ClientKeys.soundboard");
  return (
    <SoundBoardButton className={cn("create-button", className)} onClick={() => dispatch(addRow())}>
      <AddRow24 />
      <p className='font-soundboard f-ui-04 w-full truncate text-inverse'>{t("add_row_button.label")}</p>
    </SoundBoardButton>
  );
};
